import { useQuery } from '@tanstack/react-query';

import { apiGet } from '@/lib/http/client';

import type { FullEnrichCreditsUsage, UsageResponse } from './creditTypes';

export function useCreditBalance(orgId: number | undefined) {
  return useQuery<FullEnrichCreditsUsage>({
    queryKey: ['orgs', orgId, 'usage', 'fullenrich-credits'],
    queryFn: async () => {
      const res = await apiGet<UsageResponse>(`/api/orgs/${orgId}/usage/`);
      return res.fullenrich_credits;
    },
    enabled: !!orgId,
    staleTime: 60_000,
  });
}
